import r from "./highrise1310.mjs";
var a = r.Uint8Array;
export {
  a as default
};
